/* eslint-disable no-nested-ternary */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import MainBox from './components/MainBox';
import styles from './index.css';
import ToTop from '@ifeng-fe/container_channel/common/client/components/toTop';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        // 头部
        const headerData = {
            nav: { ...content.nav, limit: 17 },
            topAd: content.topAd,
            search: content.search,
            logo: content.logo,
        };

        const footerData = {
            footerNav: content.footerNav,
            footerCopyright: content.footerCopyright,
        };

        return (
            <div>
                <div className={styles.headerWrap}>
                    <Header content={headerData} />
                </div>
                <MainBox />
                <div className={styles.footerWrap}>
                    <Footer content={footerData} />
                </div>
                <ToTop windowMode="normal" />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
